import { logout, resendVerification } from './auth-api';

const escapeHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export function renderCheckEmail(root: HTMLElement, email: string, onLogout: () => void): () => void {
  root.innerHTML = `
    <div class="min-h-screen grid place-items-center px-5 py-10 bg-auth-gradient">
      <div class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift text-center">
        <div class="mb-4 text-4xl">&#9993;</div>
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">Verify your email</h1>
        <p class="mb-6 text-sm text-text-dim">
          We sent a verification link to<br />
          <span class="text-text font-medium">${escapeHtml(email)}</span>
        </p>
        <p class="mb-4 text-sm text-text-dim">Check your inbox and click the link to continue.</p>
        <p id="check-email-status" class="mb-4 text-sm min-h-[20px]"></p>
        <button type="button" id="check-email-resend"
          class="inline-block w-full p-3 mb-2 bg-gold text-bg font-bold border border-gold rounded transition-[filter] duration-[120ms] hover:brightness-110 disabled:opacity-50 cursor-pointer">
          Resend the email
        </button>
        <button type="button" id="check-email-logout"
          class="inline-block w-full p-3 bg-surface text-text-dim font-bold border border-border rounded transition-colors duration-[120ms] hover:bg-border hover:text-text cursor-pointer">
          Sign out
        </button>
      </div>
    </div>
  `;

  const btn = root.querySelector('#check-email-logout')!;
  const handler = async () => {
    await logout();
    onLogout();
  };
  btn.addEventListener('click', handler);

  // Resend: without it a user whose mail never arrived had NO action anywhere in the
  // app but signing out (which changes nothing). The button is disabled while the
  // request is in flight and afterwards — the route is throttled to 3 per 15 minutes,
  // so hammering it would only earn a 429.
  const resend = root.querySelector('#check-email-resend') as HTMLButtonElement;
  const status = root.querySelector('#check-email-status') as HTMLElement;
  const onResend = async () => {
    resend.disabled = true;
    status.className = 'mb-4 text-sm min-h-[20px] text-text-dim';
    status.textContent = 'Sending…';
    try {
      const r = await resendVerification();
      status.className = 'mb-4 text-sm min-h-[20px] text-leaf';
      status.textContent = r.alreadyVerified
        ? 'This address is already verified — sign in again to continue.'
        : 'Sent. Check your inbox (and the spam folder).';
    } catch (e) {
      status.className = 'mb-4 text-sm min-h-[20px] text-error';
      status.textContent = e instanceof Error && e.message
        ? e.message
        : "Couldn't send it right now — try again in a few minutes.";
      resend.disabled = false;   // a FAILED send must stay retryable
    }
  };
  resend.addEventListener('click', onResend);

  return () => {
    btn.removeEventListener('click', handler);
    resend.removeEventListener('click', onResend);
  };
}
